import React from 'react'
import { BrandLogo } from '../BrandLogo/BrandLogo'
import { NavMenu } from '../NavMenu/NavMenu'
import styles from './NavDesktop.module.scss'
import { useNavigation } from '../../NavigationContext'

export const NavDesktop = () => {
  const { brandLogo } = useNavigation()

  return (
    <nav className={styles['nav-desktop']}>
      <BrandLogo url={brandLogo?.url} />
      <NavMenu />
    </nav>
  )
}
